import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Row, Col } from "react-bootstrap";
import { toast } from "react-toastify";
import Modal from "react-modal";
import { fetchDefferedPaymentsData } from "../../redux/payment-reducerss/paymentSlice";
import DFPaymentLinks from "./DFPaymentLinks";
import CommonStructured from "../common-components/CommonStructured";
import UserDetails from "./UserDetails";
import CmnFilters from "../lead-management/common/CmnFilters";
import { commonPostPutApi } from "../../redux/reducers/commonApiSlice";
import { enable_fd_df_payment_creation } from "../../data/ApiEndpoints";
import { fetchFDDFPaymentCreationData } from "../../redux/prospect-reducers/prospectSlice";
import ModalHeadAndClose from "../payouts-wtf/common/ModalHeadAndClose";
import DFApprovals from "../../pages/payment-flow/deffered-approvals/DFApprovals";
import ViewDetails from "../discount-payments/ViewDetails";
import PartialDetails from "../upgrade-membership/PartialDetails";

const DFStructure = ({ userInfoData, isCustom }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { dfPaymentsLoading } = useSelector((state) => state.payment);
  const { postPutLoading } = useSelector((state) => state.common);
  const { fdDfPaymentEnableLoading, fdDfPaymentEnable } = useSelector(
    (state) => state.prospects
  );

  const isAdmin = userInfoData?.account_type === "admin";
  const isGym = userInfoData?.account_type === "gym";

  const isManagerRole = [
    "cluster_manager",
    "fitness_manager",
    "sales_manager",
    "club_manager",
  ].includes(userInfoData?.account_type);

  const [isPage, setIsPage] = useState(0);
  const [pageLimit, setPageLimit] = useState(10);
  const iniAllFilter = {
    selectedGym:
      !isAdmin && !isManagerRole
        ? {
            label: isGym ? userInfoData?.name : userInfoData?.gym_name || "",
            value:
              userInfoData?.gym_id ||
              userInfoData?.user_id ||
              userInfoData?.uid ||
              "",
          }
        : "",
    selAddedby:
      !isAdmin && !isManagerRole
        ? {
            label: userInfoData?.name || "",
            value: userInfoData?.uid || userInfoData?.user_id || "",
          }
        : "",
    isActive: "",
    selectedPlanType: "",
    selectedPlan: "",
    selectedCouplePlan: "",
    selectedPaymentModes: "",
    selectedGender: "",
    selectedExperienceLevel: "",
    selectedPaymentLocation: "",
    selLeadSource: "",

    selectedStartDate: "",
    selectedEndDate: "",

    searchString: "",

    selectedWapSent: "",
    selectedWapDelivered: "",
    selectedWapRead: "",
  };
  const [allFilters, setAllFilters] = useState(iniAllFilter);
  const iniFilters = {
    page: isPage + 1,
    limit: pageLimit || 10,
    gym_id: allFilters.selectedGym?.value || "",
    created_by: allFilters.selAddedby?.value || "",
    status: allFilters.isActive?.value || "",
    type: allFilters.selectedPlanType?.value || "",
    plan_duration: allFilters.selectedPlan?.value || "",
    is_couple: allFilters.selectedCouplePlan?.value || "",
    gender: allFilters.selectedGender?.value || "",
    payment_mode: allFilters.selectedPaymentModes?.value || "",
    experience_level: allFilters.selectedExperienceLevel?.value || "",
    payment_location: allFilters.selectedPaymentLocation?.value || "",
    lead_source: allFilters.selLeadSource?.value || "",
    start_date: allFilters.selectedStartDate || "",
    end_date: allFilters.selectedEndDate || "",
    wap_sent: allFilters.selectedWapSent?.value || "",
    wap_delivered: allFilters.selectedWapDelivered?.value || "",
    wap_read_status: allFilters.selectedWapRead?.value || "",
  };
  const [filters, setFilters] = useState(iniFilters);
  const [searchFilterApplied, setSearchFilterApplied] = useState(false);

  const [showUserInfoForm, setShowUserInfoForm] = useState(false);
  const [isFdEnable, setIsFdEnable] = useState(false);
  const [isEnableFdCreation, setIsFdCreation] = useState(isFdEnable);

  const iniModValues = {
    isModOpen: false,
    modName: "",
    rowData: "",
  };
  const [modValues, setModValues] = useState(iniModValues);

  const isCreate =
    isAdmin || isManagerRole || isEnableFdCreation ? true : false;

  const onCloseModal = () => {
    setModValues(iniModValues);
  };

  function getDefferedPaymentsData(filters) {
    dispatch(
      fetchDefferedPaymentsData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  function getFDDFPaymentsData(filters = {}) {
    dispatch(
      fetchFDDFPaymentCreationData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  const onResetFilters = () => {
    setAllFilters(iniAllFilter);
    setFilters(iniFilters);
    setShowUserInfoForm(false);
  };

  const onClickSearch = () => {
    setIsPage(0);

    if (allFilters.searchString) {
      setSearchFilterApplied(true);
      setFilters((prevs) => ({ ...prevs, search: allFilters.searchString }));
    }
  };

  const handleBack = (e) => {
    e.preventDefault();

    navigate("/open-access/all-pages", {
      state: { userInfo: userInfoData, decryptedText: userInfoData },
    });
  };

  const handleSubmitForm = async (payload) => {
    const method = "POST";
    const endpoint = enable_fd_df_payment_creation;
    const token = userInfoData?.token || "";

    try {
      const result = await dispatch(
        commonPostPutApi({ method, endpoint, payload, token })
      );

      if (result?.payload?.status) {
        toast.success(result?.payload?.message || "Success!");
        getFDDFPaymentsData();
      } else {
        const errorMessage = result?.payload?.message || result?.error?.message;
        toast.error(errorMessage || "Something Went Wrong!");
      }
    } catch (error) {
      console.error("Error making POST request:", error);
    }
  };

  useEffect(() => {
    getDefferedPaymentsData(filters);
  }, [filters]);

  useEffect(() => {
    getFDDFPaymentsData();
  }, []);

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      page: isPage + 1,
      limit: pageLimit || 10,
    }));
  }, [isPage, pageLimit]);

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      gym_id: allFilters.selectedGym?.value || "",
      created_by: allFilters.selAddedby?.value || "",
      status: allFilters.isActive?.value || "",
      type: allFilters.selectedPlanType?.value || "",
      plan_duration: allFilters.selectedPlan?.value || "",
      is_couple: allFilters.selectedCouplePlan?.value || "",
      gender: allFilters.selectedGender?.value || "",
      payment_mode: allFilters.selectedPaymentModes?.value || "",
      experience_level: allFilters.selectedExperienceLevel?.value || "",
      payment_location: allFilters.selectedPaymentLocation?.value || "",
      lead_source: allFilters.selLeadSource?.value || "",
      start_date: allFilters.selectedStartDate || "",
      end_date: allFilters.selectedEndDate || "",
      wap_sent: allFilters.selectedWapSent?.value || "",
      wap_delivered: allFilters.selectedWapDelivered?.value || "",
      wap_read_status: allFilters.selectedWapRead?.value || "",
    }));
  }, [
    allFilters.selectedGym,
    allFilters.selAddedby,
    allFilters.isActive,
    allFilters.selectedPlanType,
    allFilters.selectedPlan,
    allFilters.selectedCouplePlan,
    allFilters.selectedGender,
    allFilters.selectedPaymentModes,
    allFilters.selectedExperienceLevel,
    allFilters.selectedPaymentLocation,
    allFilters.selLeadSource,
    allFilters.selectedStartDate,
    allFilters.selectedEndDate,
    allFilters.selectedWapSent,
    allFilters.selectedWapDelivered,
    allFilters.selectedWapRead,
  ]);

  useEffect(() => {
    if (allFilters.searchString?.length === 0) {
      setSearchFilterApplied(false);
      setFilters((prevs) => ({ ...prevs, search: "" }));
      setIsPage(0);
    }
  }, [allFilters.searchString]);

  useEffect(() => {
    setIsFdCreation(isFdEnable);
  }, [isFdEnable]);

  useEffect(() => {
    const isSameState = isEnableFdCreation === isFdEnable;

    if (isAdmin && !isSameState && !fdDfPaymentEnableLoading) {
      const userData = {
        is_enabled: isEnableFdCreation ? 1 : 0,
      };

      handleSubmitForm(userData);
    }
  }, [isEnableFdCreation]);

  useEffect(() => {
    if (fdDfPaymentEnable?.status && fdDfPaymentEnable?.data?.is_enabled) {
      setIsFdEnable(true);
    } else {
      setIsFdEnable(false);
    }
  }, [fdDfPaymentEnable]);

  return (
    <>
      <Modal
        isOpen={modValues.isModOpen}
        onRequestClose={onCloseModal}
        contentLabel="Details Modal"
        ariaHideApp={false}
      >
        <div
          className={`createNewCTOModalContainer ${
            modValues.modName === "view_details" ||
            modValues.modName === "partial_details"
              ? "mod-width-50p"
              : ""
          }`}
        >
          <ModalHeadAndClose
            title={
              modValues.modName === "view_details"
                ? "Plan Details"
                : modValues.modName === "partial_details"
                ? "Partial Details"
                : " "
            }
            onClose={onCloseModal}
          />

          {modValues.modName === "view_details" ? (
            <ViewDetails rowData={modValues.rowData} isDF={true} />
          ) : modValues.modName === "partial_details" ? (
            <PartialDetails
              tbData={modValues.rowData?.partial_payment_details || []}
              isDF={true}
            />
          ) : (
            <DFApprovals isOutSource={true} />
          )}
        </div>
      </Modal>

      <Row>
        <Col>
          <CommonStructured
            pageHeading={"Deffered Payments"}
            createBtnTxt={isCreate ? "+ Add New Payment" : null}
            onClickCreateBtn={() =>
              isCreate ? setShowUserInfoForm(true) : null
            }
            isReload={() => {
              getDefferedPaymentsData(filters);
              getFDDFPaymentsData();
            }}
            onClickBackBtn={isCustom ? handleBack : null}
            isCheckboxBtn={isAdmin ? true : false}
            isEnableFdCreation={isEnableFdCreation}
            setIsFdCreation={setIsFdCreation}
            isLoading={postPutLoading || fdDfPaymentEnableLoading}
            createBtnTxt1={
              isAdmin || isManagerRole ? "← View Couple Plan Request" : null
            }
            onClickCreateBtn1={
              isAdmin || isManagerRole
                ? () =>
                    setModValues((prevs) => ({
                      ...prevs,
                      isModOpen: true,
                      modName: "couple_plan_requests",
                    }))
                : null
            }
          />
        </Col>
      </Row>

      <Row>
        <Col>
          <UserDetails
            decryptedText={userInfoData}
            callFunction={() => {
              getDefferedPaymentsData(filters);
              getFDDFPaymentsData();
            }}
            showUserInfoForm={showUserInfoForm}
            setShowUserInfoForm={setShowUserInfoForm}
          />
        </Col>
      </Row>

      <Row>
        <Col>
          <CmnFilters
            from="df"
            userInfoData={userInfoData}
            onClickReset={onResetFilters}
            filters={allFilters}
            setFilters={setAllFilters}
            onClickSearch={onClickSearch}
            searchFilterApplied={searchFilterApplied}
            isLoading={dfPaymentsLoading}
          />

          <DFPaymentLinks
            isPage={isPage}
            setIsPage={setIsPage}
            pageLimit={pageLimit}
            setPageLimit={setPageLimit}
            setModValues={setModValues}
            userInfoData={userInfoData}
          />
        </Col>
      </Row>
    </>
  );
};

export default DFStructure;
